






























import { Component, Prop, Vue } from 'vue-property-decorator';
import isArrayNotEmpty from '@/tools/isarraynotempty';
import { RoomsBlock, LessonsBlock, TestsBlock } from './components';

@Component({
  components: {
    RoomsBlock,
    LessonsBlock,
    TestsBlock,
  },
})
export default class Legend extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly isDateAfterToday!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isOpenBlock!: boolean;

  @Prop({ type: String, default: '' })
  readonly date!: string;

  @Prop({ type: Object, default: {} })
  readonly item!: Object;

  @Prop({ type: String, default: '' })
  readonly type!: string;

  @Prop({ type: [String, Array], default: '' })
  readonly student_url!: string | Array<any>;

  @Prop({ type: Array, default: () => [] })
  readonly files!: Array<any>;

  @Prop({ type: Boolean, default: false })
  readonly isResult!: boolean;

  @Prop({ type: [String, Array], default: '' })
  readonly record_url!: string | Array<any>;

  @Prop({ type: [Boolean, String], default: '' })
  readonly webinar_started!: boolean | string;

  @Prop({ type: [String, Array], default: '' })
  readonly link_state!: string | Array<any>;

  get isRoomsType() {
    return this.type === 'rooms';
  }

  get isLessonsType() {
    return this.type === 'lessons';
  }

  get isTestsType() {
    return this.type === 'tests';
  }

  get isLinksOrFiles() {
    const { links, files } = this;
    return isArrayNotEmpty(links) || files.length > 0;
  }

  lookItems() {
    this.$emit('lookItems');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/info/components/block/components/legend/Legend.vue